export default "__VITE_ASSET__GRdaSMU9EykDMf$v0bZXbA__"